import { __rest, __read, __assign } from 'tslib';
import React__default, { useState, useEffect } from 'react';
import { DEFAULT_COUNTRY } from '@invitae/nucleobase-engine-contentful';
import { mergeScriptsById } from '../utils/mergeScriptsById.esm.js';
import AppProvider from './AppProvider/AppProvider.esm.js';
import { Header } from './Header/Header.esm.js';
import baseThirdPartyScripts from './ThirdPartyScripts/baseThirdPartyScripts.esm.js';
import ThirdPartyScripts from './ThirdPartyScripts/ThirdPartyScripts.esm.js';

var NucleobaseShell = function (_a) {
    var _b;
    var thirdPartyScripts = _a.thirdPartyScripts, headerConfig = _a.headerConfig, Head = _a.Head, metadata = _a.metadata, props = __rest(_a, ["thirdPartyScripts", "headerConfig", "Head", "metadata"]);
    // to avoid rehydration issues, we need to check if the component is mounted on the client side
    var _c = __read(useState(false), 2), isClient = _c[0], setIsClient = _c[1];
    var contentfulMetadata = (_b = props === null || props === void 0 ? void 0 : props.children) === null || _b === void 0 ? void 0 : _b.fields;
    var includeHeader = headerConfig && contentfulMetadata;
    var isHeadComponent = Head === 'head';
    var mergedThirdPartyScripts = mergeScriptsById(baseThirdPartyScripts, thirdPartyScripts);
    var includeThirdPartyScripts = isClient && !isHeadComponent && mergedThirdPartyScripts.length;
    // Set to true after the component mounts
    useEffect(function () { return setIsClient(true); }, []);
    return (React__default.createElement(React__default.Fragment, null,
        includeHeader && (React__default.createElement(Header, __assign({}, headerConfig, { Head: Head, countryCode: props.countryCode || DEFAULT_COUNTRY, isCSR: isHeadComponent, metadata: contentfulMetadata || metadata }))),
        React__default.createElement(AppProvider, __assign({}, props)),
        includeThirdPartyScripts && React__default.createElement(ThirdPartyScripts, { Head: Head, scripts: mergedThirdPartyScripts })));
};

export { NucleobaseShell as default };
//# sourceMappingURL=NucleobaseShell.esm.js.map
